import React, { Component } from "react";
export default class About extends Component {
  render() {
    let bioData = this.props.bioData;
    return (
      <React.Fragment>
        <section id="about">
          <div className="row">
            <div className="three columns">
              <img className="profile-pic" src="images/peter.jpg" alt />
            </div>
            <div className="nine columns main-col">
              <h2>About Me</h2>
              <p>
                <span>
                  <b>Tech-Savvy Engineer</b>
                </span>{" "}
                who is always hungry to know programming techs/tools and
                well-versed in all phases of the software development lifecycle,
                with a strong working knowledge of algorithms and data
                structure.
              </p>
              <div className="row">
                <div className="columns contact-details">
                  <h2>Contact Details</h2>
                  <p className="address">
                    <span>{bioData.fullName}</span>
                    <br />
                    <span>{bioData.address}</span>
                    <br />
                    <span>{bioData.cellphone}</span>
                    <br />
                    <span>{bioData.email}</span>
                  </p>
                </div>
                <div className="columns download">
                  <p>
                    <a href="/resume/Barredo-Resume.pdf" className="button">
                      <i className="fa fa-download" />
                      Download Resume
                    </a>
                  </p>
                </div>
              </div>{" "}
              {/* end row */}
            </div>{" "}
            {/* end .main-col */}
          </div>
        </section>
      </React.Fragment>
    );
  }
}
